<template>
  <div
    :id="'attached_file_' + file?.id"
    class="flex flex-row gap-[6px] py-1 px-2 rounded-2xl attached_item items-center justify-center"
    :class="{ downloadable: downloadable, clicked: isClicked }"
    @click="handleClick"
  >
    <span class="text_color font-normal text-xs">{{ file?.file_name }}</span>
    <span class="font-normal text-xs secondary_color mt-0.5">
      {{ formatFileSize(file?.file_size) }}
    </span>
    <CustomLoader
      :show-label="false"
      v-if="file?.isLoading"
      size="10"
      border-width="3"
    />
    <ThemeImage
      v-else-if="downloadable"
      :icon="imageNames.DOWNLOAD_GREY"
      class="size-4 cursor-pointer"
      alt="download_icon"
    />
    <ThemeImage
      v-else
      :icon="imageNames.CLOSE_GREY"
      class="size-4 cursor-pointer"
      alt="remove_icon"
      @click.stop="handleRemove"
    />
  </div>
</template>

<script setup>
import { ref } from "vue";
import { formatFileSize } from "@/src/utils/utils.js";
import CustomLoader from "@/src/components/CustomLoader.vue";
import { uploadDownloadAPITypes } from "@/src/constants/commonConstants.js";
import { imageNames } from "@/src/constants/imageConstants.js";

const props = defineProps({
  file: {
    type: Object,
    required: true,
  },
  downloadable: {
    type: Boolean,
    required: true,
  },
  downloadApi: {
    type: String,
    default: uploadDownloadAPITypes.ATTACHMENTS,
  },
});

const emit = defineEmits(["remove"]);

const isClicked = ref(false);

const handleRemove = () => {
  emit("remove", props.file.id);
};

const handleClick = () => {
  if (props.downloadable) {
    isClicked.value = true;
    setTimeout(() => {
      isClicked.value = false;
    }, 200);

    const link = document.createElement("a");
    const fileId = props.file.id;

    if (props.downloadApi === uploadDownloadAPITypes.CONVERSATION_ATTACHMENTS) {
      link.href = `/api/conversation_attachments/${fileId}/download`;
    } else {
      link.href = `/api/attachments/${fileId}/download`;
    }

    link.download = props.file.file_name;
    link.click();
  }
};
</script>

<style scoped>
.attached_item {
  border: 1px solid var(--white-opacity-8);
  background-color: var(--white-opacity-14);
  transition: all 0.2s ease;
}

.downloadable {
  cursor: pointer;
}

.clicked {
  transform: scale(0.95);
  opacity: 0.8;
}
</style>
